import coreStore from "./core-store";

const remoteResource = 'cashflow/api/v1/cash-flow-report-definitions';

const store = coreStore.createCoreStore('cashflowReportDefinition', remoteResource)

export default store;
